import * as React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const Content = ({ className, children }) => <div className={className}>{children}</div>;

Content.defaultProps = {
  className: ''
};

Content.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default connect()(Content);



// WEBPACK FOOTER //
// ./src/components/ContactForm/Content.jsx